<template>
  <div id="listadogruposusuariosregistrados">
    <div v-if="!usersMantainer.length">
      <div class="ui icon warning message">
        <i class="user icon"></i>
        <div class="content">
          <div class="header">
            {{ $t("components.usersGroups.No_hay_usuarios") }}
          </div>
          <p>{{ $t("components.usersGroups.Aniade_usuarios") + ' ' + appParentName }}</p>
        </div>
      </div>
    </div>

    <table v-if="usersMantainer.length" class="ui compact celled definition table selectable sortable">
      <thead class="full-width">
        <tr>
          <th class="left aligned six wide">{{ $t("components.usersGroups.Nombre") }}</th>
          <th class="center aligned nine wide">{{ $t("components.usersGroups.Usuarios_asociados") }}</th>
          <th class="one wide no-sort"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in usersMantainer" v-bind:key="u._id">
          <td>
            <div class="ui accordion">
              <div class="title" style="font-size: 16px;">
                 {{ u.name }}
              </div>
              <div class="content ">
                <p class="transition visible" style="display: block !important; margin-top:10px;">
                  <strong>{{ $t("components.usersGroups.Usuarios_asociados") }}</strong>: <span style="font-weight: normal" v-if="u.users.length === 0">{{ $t("components.usersGroups.Ninguno") }}</span>
                  <ul style="font-weight: normal !important; margin-top:5px;" v-if="u.users.length > 0">
                    <li v-for="up in getListaUsuariosAsignados(u.users)" v-bind:key="up._id">
                      {{ up.name }}
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </td>
          <td class="center aligned">{{ getListaCortaUsuariosAsignados(u, 10) }}</td>
          <td class="center aligned collapsing">
            <div class="ui icon buttons mini">
              <router-link class="item" :to="'/usersGroups/' + u._id">
                <button class="ui button">
                  <i class="pencil alternate icon"></i>
                </button>
              </router-link>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import { Config } from '../config';
import Vue from 'vue';

export default {
  name: 'RegisteredUsersGroups',
  data: function () {
    return {
      usersMantainer: [],
      usersPlainUser: [],
      moment: Vue.moment,
      appParentName: Config.parentAppName
    };
  },
  methods: {
    refresh: function () {
      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/usersGroups').then(response => {
        if (response) {
          this.usersPlainUser = response.data.usersPlainUser;
          this.usersMantainer = response.data.usersMantainer;
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.common.Error'),
          text: e
        });
      });
    },
    getNombreUsuarioPlainUser: function (userPlainUserId) {
      const userPlainUser = this.usersPlainUser.find((userTemp) => userTemp._id === userPlainUserId);

      return userPlainUser.name;
    },
    getListaUsuariosAsignados: function (users) {
      const listaUsuariosAsignados = [];

      for(const user of users) {
        listaUsuariosAsignados.push({ _id: user, name: this.getNombreUsuarioPlainUser(user) });
      }

      listaUsuariosAsignados.sort((c1, c2) => {
        if (c1.name < c2.name) {
          return -1;
        } else if (c1.name > c2.name) {
          return 1;
        } else {
          return 0;
        }
      });

      return listaUsuariosAsignados;
    },
    getListaCortaUsuariosAsignados: function (userMantainer, numMax) {
      const listaUsuariosAsignados = this.getListaUsuariosAsignados(userMantainer.users);

      let listaCortaUsuariosAsignados = "";

      for(let i = 0; i < numMax; i++) {
        if (i >= listaUsuariosAsignados.length) {
          break;
        }

        listaCortaUsuariosAsignados += listaUsuariosAsignados[i].name;

        if ((i === (numMax - 1)) || (i === listaUsuariosAsignados.length - 1)) {
          break;
        }

        listaCortaUsuariosAsignados += ", ";
      }

      if (listaUsuariosAsignados.length > numMax) {
        listaCortaUsuariosAsignados += ", +" + (listaUsuariosAsignados.length - numMax);
      }

      return listaCortaUsuariosAsignados;
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('table').DataTable({
        language: this.$i18n.t('components.datatable_language')
      })
      .on('draw', () => {
        $('#listadogruposusuariosregistrados .accordion').accordion({
          selector: {
            trigger: '.title'
          }
        });
      });

      $('#listadogruposusuariosregistrados .accordion').accordion({
        selector: {
          trigger: '.title'
        }
      });
    }, 500);
  }
};
</script>
